import { lazy } from 'react'

export const DeleteProductFunctionalityModalAsync = lazy(
    () => import('./DeleteProductFunctionalityModal')
        .then((module) => {
            return { default: module.DeleteProductFunctionalityModal }
        })
)
